import { Routes } from '@angular/router';
import { authPageGuard } from './pages/auth-page/guards/auth-page.guard';
import { dashboardPageGuard } from './pages/dashboard-page/guards/dashboard-page.guard';

export const routes: Routes = [
  {
    path: 'dashboard',
    loadComponent: () =>
      import('./pages/dashboard-page/dashboard-page.component').then(
        (m) => m.DashboardPageComponent,
      ),
    canMatch: [dashboardPageGuard],
    children: [
      {
        path: 'streaks',
        title: 'Dashboard | The Streak App',
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import('./pages/dashboard-page/pages/streak-details-page/streak-details-page.component').then(
                (m) => m.StreakDetailsPageComponent,
              ),
          },
          {
            path: '',
            loadComponent: () =>
              import('./pages/dashboard-page/components/streaks-tab/streaks-tab.component').then(
                (m) => m.StreaksTabComponent,
              ),
          },
        ],
      },
      {
        path: '',
        redirectTo: 'streaks',
        pathMatch: 'full',
      },
      {
        path: 'leaderboard',
        loadComponent: () =>
          import('./pages/dashboard-page/components/leaderboard-tab/leaderboard-tab.component').then(
            (m) => m.LeaderboardTabComponent,
          ),
      },
      {
        path: 'account',
        loadComponent: () =>
          import('./pages/dashboard-page/components/account-tab/account-tab.component').then(
            (m) => m.AccountTabComponent,
          ),
      },
      {
        path: '**',
        redirectTo: 'streaks',
      },
    ],
  },
  {
    path: 'auth',
    title: 'Login | The Streak App',
    loadComponent: () =>
      import('./pages/auth-page/auth-page.component').then(
        (m) => m.AuthPageComponent,
      ),
    canMatch: [authPageGuard],
  },
  {
    path: 'streaks-for-strava',
    title: 'Streaks for Strava | The Streak App',
    loadComponent: () =>
      import('./pages/streaks-for-strava-page/streaks-for-strava-page.component').then(
        (m) => m.StreaksForStravaPageComponent,
      ),
  },
  {
    path: 'fix-streak-count',
    title: 'Why is my streak count wrong? | The Streak App',
    loadComponent: () =>
      import('./pages/fix-streak-count-page/fix-streak-count-page.component').then(
        (m) => m.FixStreakCountPageComponent,
      ),
  },
  {
    path: 'streak-recovery',
    title: 'Streak Recovery | The Streak App',
    loadComponent: () =>
      import('./pages/streak-recovery-page/streak-recovery-page.component').then(
        (m) => m.StreakRecoveryPageComponent,
      ),
  },
  {
    path: '',
    title: 'Streaks for Strava | The Streak App',
    loadComponent: () =>
      import('./pages/main-page/main-page.component').then(
        (m) => m.MainPageComponent,
      ),
  },
  { path: '**', redirectTo: '' },
];
